import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'surveys/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('surveys/', '')
      .toLowerCase();
  }
}
